import * as React from "react";
import {PropsWithChildren, useEffect, useState} from "react";
import {AppContextData} from "../typings";
import {CompanyAccountData} from "../../reception-service/services/react-common/typings";

export const AppContext = React.createContext({} as AppContextData);

export const AppProvider = ({children}: PropsWithChildren<any>): JSX.Element => {

    const [companyAccount, setCompanyAccount] = useState<CompanyAccountData | null>(null);
    const [token, setToken] = useState<string | null>(null);
    const [spinner, setSpinner] = useState<boolean>(false);

    useEffect(() => {
        // 以前のトークンを設定
        setToken(localStorage.getItem("alcohol_token"));
    }, []);

    const defaultContext: AppContextData = {

        token: token,
        setToken: (d) => {
            setToken(d);

            if (d != null) {
                localStorage.setItem("alcohol_token", d);
            } else {
                localStorage.removeItem("alcohol_token");
            }
        },

        spinner: spinner,
        setSpinner: setSpinner,

        companyAccount: companyAccount,
        setCompanyAccount: (companyAccount) => {
            setCompanyAccount(companyAccount);
        },
    };

    return <AppContext.Provider value={defaultContext}>
        {children}
    </AppContext.Provider>

};
